var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiraeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 316.42 376.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fa9579;}.cls-2,.cls-4{fill:#654062;}.cls-3{fill:#fff;}.cls-4{font-size:30px;font-family:NotoSansKR-Light-KSCpc-EUC-H, Noto Sans KR;letter-spacing:0em;}.cls-5{letter-spacing:-0.05em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.52,0H291.13c14,0,25.31,10.29,25.29,23V147.32L0,139.12.24,22.88C.26,10.24,11.57,0,25.52,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,131l316.39,11-.22,139.16c0,15.49-11.36,28-25.32,28H25.24c-14,0-25.27-13.14-25.24-28.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.71,174.15H90.18a8.8,8.8,0,0,0,5.23-1.61c3.23-2.42,4.59-9.84,8.46-18.06,5.63-11.93-1.84-49-9.12-63.37C88.63,79,77,65.34,55.26,65s-25.42,14-42.56,26.69C2.91,98.9.12,116.17,0,131.69c-.08,11.64,2.05,18.74,3.14,23.44,1.67,7.2,2.65,10.24,5.35,13.37C9.55,169.73,12.73,174.15,14.71,174.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73,233.3H33.29a2,2,0,0,1-1.86-1.55L28.67,223c-.49-1.55.47-3.21,1.86-3.21H75.81c1.39,0,2.35,1.66,1.86,3.21l-2.76,8.8A2.06,2.06,0,0,1,73,233.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79.43,213H26.91a2,2,0,0,1-1.86-1.54l-2.76-8.81c-.49-1.55.47-3.21,1.86-3.21h58c1.39,0,2.35,1.65,1.86,3.21l-2.75,8.81A2.05,2.05,0,0,1,79.43,213Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.05,192.6H20.52a2,2,0,0,1-1.85-1.54l-2.77-8.82c-.48-1.55.47-3.2,1.86-3.2H88.37c1.44,0,2.4,1.77,1.81,3.34l-3.32,8.82A2,2,0,0,1,85.05,192.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.67,253.64h-27a2,2,0,0,1-1.85-1.54L35,243.29c-.49-1.55.47-3.21,1.86-3.21H69.44c1.38,0,2.34,1.66,1.85,3.21l-2.76,8.81A2,2,0,0,1,66.67,253.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120,174.15h75.47a8.83,8.83,0,0,0,5.23-1.61c3.22-2.42,4.58-9.84,8.46-18.06,5.62-11.93-1.84-49-9.12-63.37C194,79,182.28,65.34,160.58,65s-25.41,14-42.56,26.69c-9.79,7.26-12.58,24.53-12.69,40.05-.09,11.64,2,18.74,3.13,23.44,1.68,7.2,2.65,10.24,5.35,13.37C114.87,169.73,118.05,174.15,120,174.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M178.23,233.3H138.47a2,2,0,0,1-1.86-1.55l-2.76-8.8c-.49-1.55.47-3.21,1.86-3.21H181c1.39,0,2.35,1.66,1.86,3.21l-2.76,8.8A2,2,0,0,1,178.23,233.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M184.62,213H132.09a2,2,0,0,1-1.86-1.54l-2.76-8.81c-.49-1.55.47-3.21,1.86-3.21h58c1.39,0,2.35,1.65,1.86,3.21l-2.75,8.81A2,2,0,0,1,184.62,213Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M190.23,192.6H125.7a2,2,0,0,1-1.85-1.54l-2.76-8.82c-.49-1.55.47-3.2,1.85-3.2h70.61c1.44,0,2.4,1.77,1.81,3.34L192,191.2A2,2,0,0,1,190.23,192.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.85,253.64h-27A2,2,0,0,1,143,252.1l-2.77-8.81c-.48-1.55.47-3.21,1.86-3.21h32.54c1.38,0,2.34,1.66,1.86,3.21l-2.77,8.81A2,2,0,0,1,171.85,253.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M225.28,174.15h75.47a8.84,8.84,0,0,0,5.24-1.61c3.22-2.42,4.58-9.84,8.46-18.06,5.62-11.93-1.84-49-9.13-63.37C299.21,79,287.53,65.34,265.83,65s-25.41,14-42.56,26.69c-9.79,7.26-12.58,24.53-12.7,40.05-.08,11.64,2.05,18.74,3.14,23.44,1.67,7.2,2.65,10.24,5.35,13.37C220.12,169.73,223.3,174.15,225.28,174.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.62,233.3H243.86a2,2,0,0,1-1.86-1.55l-2.76-8.8c-.49-1.55.47-3.21,1.86-3.21h45.28c1.39,0,2.35,1.66,1.86,3.21l-2.76,8.8A2,2,0,0,1,283.62,233.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M290,213H237.48a2,2,0,0,1-1.86-1.54l-2.76-8.81c-.49-1.55.47-3.21,1.86-3.21h58c1.39,0,2.35,1.65,1.86,3.21l-2.75,8.81A2,2,0,0,1,290,213Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M295.62,192.6H231.09a2,2,0,0,1-1.85-1.54l-2.77-8.82c-.48-1.55.48-3.2,1.86-3.2h70.61c1.44,0,2.4,1.77,1.81,3.34l-3.32,8.82A2,2,0,0,1,295.62,192.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M277.24,253.64h-27a2,2,0,0,1-1.86-1.54l-2.77-8.81c-.48-1.55.47-3.21,1.86-3.21H280c1.38,0,2.34,1.66,1.86,3.21l-2.77,8.81A2,2,0,0,1,277.24,253.64Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(11.15 345.17)"
  }, "MIRAE DEN", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 148.68,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 164.73,
    y: 0
  }, "AL CLINIC"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiraeLogo);
export default __webpack_public_path__ + "static/media/miraeLogo.408f78fd4807852d76711610b0675699.svg";
export { ForwardRef as ReactComponent };